import React, { FC } from 'react';

import BasicModal from 'components/modals/basicModal';

import aampeTheme from '../../../../constants/aampeTheme';

interface BasicTopicModalProps {
    handleClose: () => void;
    header: string;
}

const BasicTopicModal: FC<React.PropsWithChildren<BasicTopicModalProps>> = ({
    handleClose,
    children,
    header,
}) => {
    return (
        <BasicModal
            width="480px"
            childContainerStyle={{
                gap: aampeTheme.spacing4(6),
                display: 'flex',
                flexDirection: 'column',
            }}
            header={header}
            handleClose={handleClose}
            headerStyle={{
                fontSize: aampeTheme.size.font.title,
                fontWeight: aampeTheme.weights.medium,
                color: aampeTheme.colors.neutral09,
                backgroundColor: aampeTheme.colors.white,
                padding: aampeTheme.spacing4(6, 6, 1, 6),
            }}
        >
            {children}
        </BasicModal>
    );
};

export default BasicTopicModal;
